import { auth, database } from '../firebaseConfig';
import { ref as dbRef, get, set } from "firebase/database";

export const UserRoles = {
  ADMIN: 'admin',
  USER: 'user',
  GUEST: null
};

export const Permissions = {
  CREATE_ALBUM: 'CREATE_ALBUM',
  EDIT_ALBUM: 'EDIT_ALBUM',
  DELETE_ALBUM: 'DELETE_ALBUM',
  CREATE_PHOTO: 'CREATE_PHOTO',
  EDIT_PHOTO: 'EDIT_PHOTO',
  DELETE_PHOTO: 'DELETE_PHOTO'
};

const rolePermissions = {
  [UserRoles.ADMIN]: Object.values(Permissions),
  [UserRoles.USER]: [
    Permissions.CREATE_ALBUM,
    Permissions.CREATE_PHOTO,
    Permissions.EDIT_PHOTO,
    Permissions.VIEW_ONLY
  ],
  [UserRoles.GUEST]: [
    Permissions.VIEW_ONLY
  ]
};

export const getUserRole = async (userId) => {
  if (!userId) return UserRoles.GUEST;
  
  // First check main users collection
  const mainUserRef = dbRef(database, `users/${userId}/role`);
  const mainSnapshot = await get(mainUserRef);
  
  if (mainSnapshot.exists()) {
    const role = mainSnapshot.val();
    console.log(`Retrieved role from main users for ${userId}:`, role);
    return role;
  }
  
  // Fallback to gallery/active/users
  const activeUserRef = dbRef(database, `gallery/active/users/${userId}/role`);
  const activeSnapshot = await get(activeUserRef);
  const role = activeSnapshot.val() || UserRoles.USER;
  console.log(`Retrieved role from active users for ${userId}:`, role);
  return role;
};

export const hasPermission = (userRole, permission) => {
  console.log('Checking permission:', { userRole, permission });
  
  if (userRole === 'admin') {
    return true;
  }

  if (userRole === 'user') {
    const userPermissions = [
      Permissions.CREATE_ALBUM,
      Permissions.EDIT_ALBUM,
      Permissions.DELETE_ALBUM,
      Permissions.CREATE_PHOTO,
      Permissions.EDIT_PHOTO,
      Permissions.DELETE_PHOTO
    ];
    const hasPerm = userPermissions.includes(permission);
    console.log('User has permission:', hasPerm);
    return hasPerm;
  }

  return false;
};

export const setUserRole = async (userId, role) => {
  if (!userId) return;
  const userRoleRef = dbRef(database, `users/${userId}/role`);
  await set(userRoleRef, role);
}; 